/***
*服务网点
***/
<template>
    <div class="outlet">
        <SubNav v-bind:active="1"></SubNav>
        <div class="bg">
            <div id="container"></div>
            <div class="search">
                <div class="title" @click="getServicePointList">
                    <i class="fa fa-map-marker" aria-hidden="true"></i><span>&nbsp;&nbsp;点击获取附近服务点</span>
                </div>
                <div class="in">
                    <input v-model="searchInput" type="text" placeholder=""><i class="fa fa-search" aria-hidden="true" @click="searchPlace"></i>
                </div>
                <div class="result" v-if="points.length != 0">
                    <Row :gutter="6" justify="center" class-name="one" v-for="(item, index) in points" :key="index">
                        <Col span="3">
                            <strong>{{index + 1}}</strong>
                        </Col>
                        <Col span="21">
                            <div @click="toPlace(item.lat, item.long)">
                                <h3>{{item.name}}</h3>
                                <p>{{item.phone}}</p>
                                <p>{{item.address}}</p>
                                <p>距离您&nbsp;{{item.distance}}&nbsp;公里</p>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
        <div class="info" v-if="points.length != 0">
            <Row :gutter="6" justify="center">
                <Col span="8">
                    <h3><i class="fa fa-bus" aria-hidden="true"></i>&nbsp;&nbsp;距离您最近的服务点</h3>
                    <h4>{{points[0].name}}</h4>
                </Col>
                <Col span="8">
                    <div class="center">
                        <h3>{{points[0].phone}}</h3>
                        <h3>{{points[0].address}}</h3>
                        <br>
                        <p>营业时间</p>
                        <p><span>周一至周五</span><span style="float: right">8:30 - 18:30</span></p>
                        <p><span>周六</span><span style="float: right">8:30 - 20:30</span></p>
                        <p><span>周日</span><span style="float: right">8:30 - 20:30</span></p>
                    </div>
                </Col>
                <Col span="8">
                    <Row :gutter="6" justify="center">
                        <Col span="8">
                            <a style="display: block" class="r-main" target="_blank" v-bind:href="end">
                                <i class="fa fa-paper-plane-o" aria-hidden="true"></i>
                                <p>路线导航</p>
                            </a>
                        </Col>
                        <Col span="8">
                            <div class="r-main">
                                <i class="fa fa-map-marker" aria-hidden="true"></i>
                                <p>距离您&nbsp;{{points[0].distance}}&nbsp;公里</p>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="r-main">
                                <i class="fa fa-phone" aria-hidden="true"></i>
                                <p>{{points[0].phone}}</p>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>
    import * as service from '@/controller/service'
    import SubNav from './SubNav.vue'
    import SmallLogo from '../../../public/img/small-logo.png'

    export default {
        name: "network",
        data() {
            return {
                searchInput: '',
                location: {
                    longitude: 0.0, //经度y
                    latitude: 0.0 //纬度x
                },
                mapObj: {},
                points: [], //服务点列表
                end: 'http://www.baidu.com' //导航重点
            }
        },
        components: {
            SubNav
        },
        mounted() {

        },
        methods: {
            getLocation() {
                this.initMap()
            },
            // 初始化地图
            initMap() {

                this.mapObj = new AMap.Map('container', {
                    resizeEnable: true, //自适应大小
                    // center: [this.location.longitude, this.location.latitude],
                    zoom: 10//初始视窗
                })

            },
            // 获取用户当前位置
            getCurrentPosition(hasSearch) {

                return new Promise((resolve, reject) => {

                    if (Object.keys(this.mapObj).length == 0) {
                        this.initMap()
                    }

                    this.mapObj.plugin('AMap.Geolocation',() => {
                        let geolocation = new AMap.Geolocation({
                            enableHighAccuracy: true,
                            // 设置定位超时时间，默认：无穷大
                            timeout: 10000,
                        })

                        // 不是点的搜索，不要定位到当前位置
                        if(hasSearch != 1) {
                            this.mapObj.addControl(geolocation)
                        }

                        this.mapObj.addControl(geolocation)
                        geolocation.getCurrentPosition()
                        AMap.event.addListener(geolocation, 'complete', (data) => {

                            // 不是点的搜索，不要填入当前位置信息
                            if(hasSearch != 1) {
                                this.searchInput = data.formattedAddress
                            }

                            this.location.longitude = data.position.getLng()
                            this.location.latitude = data.position.getLat()
                            resolve(data.position.getLng() + ',' + data.position.getLat())

                        }) //返回定位信息
                        AMap.event.addListener(geolocation, 'error', (data) => {
                            if (data.info == 'FAILED') {
                                this.$Message.error('获取您的位置信息失败')
                            }
                        })
                    })
                })

            },
            // 放置地图服务点
            pointList(markers) {

                let icon = new AMap.Icon({
                    size: new AMap.Size(50, 50),    // 图标尺寸
                    image: SmallLogo,  // Icon的图像
                    imageSize: new AMap.Size(25, 25)   // 根据所设置的大小拉伸或压缩图片
                })

                let arr = new Array()
                markers.forEach(function (e) {

                    arr.push(new AMap.Marker({
                        icon: icon,
                        position: new AMap.LngLat(e.long, e.lat)
                    }))

                })

                this.mapObj.add(arr)

            },
            //获取全部的服务点列表
            getServicePointList(type) {
                this.getCurrentPosition(type)
                    .then(coordinate => {

                        service.fetchServicePointList(coordinate)
                            .then(result => {

                                this.points = result
                                this.pointList(result)
                                this.navigationPath()
                            })
                    })
            },
            //搜索位置
            searchPlace() {

                if (Object.keys(this.mapObj).length == 0) {
                    this.initMap()
                }

                this.mapObj.plugin('AMap.Geocoder', () => {
                    var geocoder = new AMap.Geocoder({
                        // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                        city: '全国'
                    })

                    geocoder.getLocation(this.searchInput, (status, result) => {
                        if (status === 'complete' && result.info === 'OK') {

                            this.mapObj.setCenter(new AMap.LngLat(result.geocodes[0].location.lng, result.geocodes[0].location.lat))
                            this.mapObj.setZoom(13)

                            //加一个标记
                            var searchMarker = new AMap.Marker({
                                position: new AMap.LngLat(result.geocodes[0].location.lng, result.geocodes[0].location.lat),
                                title: '北京'
                            })

                            this.mapObj.add(searchMarker)

                            service.fetchServicePointList(result.geocodes[0].location.lng + ',' + result.geocodes[0].location.lat)
                                .then(result => {

                                    // console.log(result)

                                    this.points = result
                                    this.pointList(result)
                                    this.navigationPath()
                                })

                        }
                    })
                })


            },
            toPlace(lat, long) {
                this.mapObj.setCenter(new AMap.LngLat(long, lat))
                this.mapObj.setZoom(13)
            },
            navigationPath() {



                this.mapObj.plugin('AMap.Geolocation',() => {
                    let geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,
                        // 设置定位超时时间，默认：无穷大
                        timeout: 10000,
                    })

                    geolocation.getCurrentPosition()
                    AMap.event.addListener(geolocation, 'complete', (data) => {


                        this.end = 'https://uri.amap.com/navigation?from='+data.position.getLng()+','+data.position.getLat()+',您的位置&to='+this.points[0].long+','+this.points[0].lat+',目的地'

                    }) //返回定位信息
                    AMap.event.addListener(geolocation, 'error', (data) => {
                        if (data.info == 'FAILED') {
                            this.$Message.error('获取您的位置信息失败')
                        }
                    })
                })






            }
        }
    }
</script>

<style scoped lang="stylus">
.outlet
    .bg
        width 1000px
        height 680px
        margin 32px auto 0px
        background-image url("../../../public/img/servicebg2.jpg")
        background-size cover
        background-repeat no-repeat
        padding-top 130px
        padding-left 70px
        position relative
        #container
            background-color transparent
            width 100%
            height 100%
            position absolute
            top 0
            left 0
            opacity 1
        .search
            position absolute
            width 380px
            background-color white
            text-align left
            min-height 120px
            .title
                background-color #EE1234
                height 60px
                color white
                font-size 22px
                padding 14px
                cursor pointer
            .in
                background-color white
                height 60px
                border-bottom 1px solid gainsboro
                input
                    height 100%
                    width 330px
                    outline none
                    font-size 16px
                    padding 5px
                    border none
                i
                    font-size 24px
                    color #EE1234
                    padding-left 10px
                    cursor pointer
            .result
                background-color white
                max-height 400px
                overflow scroll
                .one
                    padding 4px
                    cursor pointer
                    &:hover h3
                        color #EE1234
                    strong
                        color #F4B77E
                        font-size 20px
                        text-align center
                        display block
                        padding-top 24px
                    h3
                        transition:color .2s ease-in
                    p
                        color gray
    .info
        background-color #F7F7F7
        min-height 100px
        width 1000px
        margin 0 auto 64px
        padding 42px 0px 32px
        h3
            font-size 18px
        h4
            font-size 16px
            color #EE1234
            margin-top 12px
        .center
            border-left 1px solid #E4E4E4
            border-right 1px solid #E4E4E4
            padding-left 18px
            padding-right 18px
            h3
                font-size 16px
                font-weight normal
            p
                text-align left
                font-size 14px
        .r-main
            display block
            color #2c3e50
            text-decoration none
            padding-top 12px
            cursor pointer
            i
                font-size 24px
                color #EE1234
            p
                font-size 14px
                padding-top 12px



</style>
